import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        contactNameComment: {
            color: theme.palette.secondary[700],
        },
        contactCard: {
            display: 'block',
        },
        container: {
            display: 'grid',
            gridGap: 10,
            padding: '10px 0',
            gridTemplateColumns: 'repeat(4, 1fr)',
        },
        linkToEngagement: {
            paddingTop: theme.spacing(2),
        },
    }
})

export default useStyles
